import * as React from 'react';
import { FunctionComponent } from 'react';
import '../../../../../../../components/GeneralMessagePreview/GeneralMessagePreview.css';
import { GeneralMessagePreviewPush } from '../../../../../../../components/GeneralMessagePreview/GeneralMessagePreviewPush';
import { GeneralMessagePreviewTabs } from '../../../../../../../components/GeneralMessagePreview/GeneralMessagePreviewTabs';
import { TournamentCustomNotificationPreviewEmail } from '../../../../../../../views/GenericView/AdminSUView/Tournaments/CreateTournamentCustomNotificationsView/TournamentCustomNotificationPreviewEmail';
import { Attachment } from '../../../../../../../models/generalMessage';

interface Props {
  messageEmailSubject: string;
  messageEmailBody: string;
  messagePushTitle: string;
  messagePushBody: string;
  messageAttachments: Attachment[];
}

export const EventCustomNotificationPreview: FunctionComponent<Props> = props => (
  <div className="container-fluid px-0">
    <div className="bGeneralMessagePreview row mx-0">
      <div className="col-12 px-0">
        <GeneralMessagePreviewTabs tabs={['Email preview', 'Push preview']}>
          <TournamentCustomNotificationPreviewEmail
            messageEmailSubject={props.messageEmailSubject}
            messageEmailBody={props.messageEmailBody}
            messageAttachments={props.messageAttachments}
          />

          <GeneralMessagePreviewPush
            messagePushTitle={props.messagePushTitle}
            messagePushBody={props.messagePushBody}
          />
        </GeneralMessagePreviewTabs>
      </div>
    </div>
  </div>
);

EventCustomNotificationPreview.displayName = 'EventCustomNotificationPreview';
